import Get from '../services/Get';
import PostFormData from '../services/PostFormData';

import { nexcareVersion } from '../config/serviceConfig';

const getListContact = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/contact?page=${page}&limit=${limit}&filter=customer_id eq ${filter}`, token);
const getSearchContact = (page, limit, filter, id, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/contact?page=${page}&limit=${limit}&filter=pic_name like ${filter}, customer_id eq ${id}`, token);

const getListChannel = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/remark/channel?page=${page}&limit=${limit}`, token);

const getListCustomer = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/user-customer/distributor?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc`, token);
const getSearchCustomer = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/user-customer/distributor?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc`, token);

const getListPrincipal = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/user-customer/pic-principal?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc&distributor_id=${id}`, token);
const getSearchPrincipal = (page, limit, filter, id, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/user-customer/pic-principal?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc&distributor_id=${id}`, token);

const getListComplaint = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/complaint?page=${page}&limit=${limit}`, token);
const getListComplaintCategory = (page, limit, value, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/complaint-category?page=${page}&limit=${limit}&filter=complaint_id eq ${value}`, token);
const getListComplaintSub = (page, limit, value, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/complaint-sub?page=${page}&limit=${limit}&filter=complaint_category_id eq ${value}`, token);

const getListNsCode = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/ns-codes?page=${page}&limit=${limit}&customer_id=${id}`, token);
const getListBranchId = (page, limit, id, nsCode, token) => Get(`/${nexcareVersion}/nexcare/ticket-create/ns-codes?page=${page}&limit=${limit}&customer_id=${id}&ns_code=${nsCode}`, token);

const postDataCreateTicket = (data, token) => PostFormData(`/${nexcareVersion}/nexcare/ticket/phone`, data, token);

const API_CREATE_TICKET = {
    getListCustomer,
    getSearchContact,
    getSearchCustomer,
    getListPrincipal,
    getSearchPrincipal,
    getListComplaint,
    getListComplaintCategory,
    getListComplaintSub,
    getListContact,
    getListChannel,
    getListNsCode,
    getListBranchId,
    postDataCreateTicket,
}

export default API_CREATE_TICKET;